type Wave = OscillatorType

let ctx: AudioContext | null = null

function getCtx(): AudioContext | null {
  if (typeof window === 'undefined') return null
  try {
    const Ctor =
      window.AudioContext ??
      (window as unknown as { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext
    if (!Ctor) return null
    ctx = ctx ?? new Ctor()
    // Browsers suspend the context until a user gesture unlocks it.
    if (ctx.state === 'suspended') void ctx.resume()
    return ctx
  } catch {
    return null
  }
}

export function beep(freq: number, dur: number, type: Wave = 'triangle'): void {
  const ac = getCtx()
  if (!ac) return
  try {
    const osc = ac.createOscillator()
    const gain = ac.createGain()
    osc.type = type
    osc.frequency.value = freq
    gain.gain.value = 0.06
    osc.connect(gain)
    gain.connect(ac.destination)
    osc.start()
    gain.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + dur)
    osc.stop(ac.currentTime + dur)
  } catch {
    /* audio is a nicety, never a failure */
  }
}

export function fanfare(): void {
  beep(660, 0.09)
  setTimeout(() => beep(880, 0.12), 90)
  setTimeout(() => beep(1180, 0.16), 190)
}

export function buzz(): void {
  beep(190, 0.22, 'sawtooth')
}
